import { IntegrationType } from '@accedo/one-plugin-sdk';

import { useConfig } from '#/hooks/useConfig';
import { useFirstPluginConfig } from '#/plugins/hooks/useFirstPluginConfig';

// Be aware that we need to keep these types manually in sync with the integration manifest.
// https://github.com/Accedo-Products/one-integrations/blob/5c830a80cd3952430f4c344c844e8fa469846479/src/service/client-manifest-provider/manifests/definitions/paywall/manifest-paywall-mpp.yml
export type Brand =
  | 'VISA'
  | 'MASTERCARD'
  | 'AMEX'
  | 'DISCOVER'
  | 'JCB'
  | 'DINERS'
  | 'UNION_PAY';

interface PaymentCardLogos {
  isEnabled: boolean;
  staticFilePrefix?: string;
  brands: Brand[];
}

const EMPTY_BRANDS: Brand[] = [];

// Hook to determine if payment card logos should be displayed.
export const usePaymentCardLogos = (): PaymentCardLogos => {
  const {
    app: { staticFilePrefix },
  } = useConfig();

  const integrationConfig = useFirstPluginConfig(IntegrationType.PAYWALL);

  const brands =
    integrationConfig?.properties?.displayedCreditCardLogos ?? EMPTY_BRANDS;
  const isEnabled = !!brands.length;

  return {
    isEnabled,
    staticFilePrefix,
    brands,
  };
};
